import React, { useState } from 'react';
import { string, any, bool } from 'prop-types';
import { Row, Column } from '../Grid';
import Hide from '../Hide';
import Icon from '../Icon';
import { CULTURED, GREEN_DARK } from '../../../utils/colors';

const MobileAcordion = ({
    backgroundColorOpened,
    backgroundColorClosed,
    defaultOpened,
    arrowColor,
    maxHeight,
    left,
    boxShadow,
    children,
    ...props
}) => {
    const [collapsed, setCollapsed] = useState(!defaultOpened);
    return (
        <Row border='1px solid #eaeaea' borderRadius={4} direction='column !important' boxShadow={boxShadow} noFlex {...props}>
            <Row
                backgroundColor={!collapsed ? backgroundColorOpened : backgroundColorClosed}
                pX={16}
                pY={10}
                pointer
                onClick={() => setCollapsed(!collapsed)}
                borderRadius={!collapsed ? '4px 4px 0 0' : 4}
                maxHeight={maxHeight}
            >
                <Column direction='row' align='center'>
                    { left }
                </Column>
                <Column align='flex-end' justify='center' noFlex>
                    <Icon name={collapsed ? 'chebron_down' : 'chebron_up'} color={arrowColor} size={12} />
                </Column>
            </Row>
            <Hide condition={collapsed}>
                { children }
            </Hide>
        </Row>
    );
};

MobileAcordion.propTypes = {
    children: any,
    maxHeight: string,
    left: any,
    backgroundColorOpened: string,
    backgroundColorClosed: string,
    arrowColor: string,
    defaultOpened: bool,
    boxShadow: bool
};

MobileAcordion.defaultProps = {
    children: null,
    maxHeight: '40px',
    left: null,
    backgroundColorOpened: CULTURED,
    backgroundColorClosed: CULTURED,
    arrowColor: GREEN_DARK,
    defaultOpened: false,
    boxShadow: false
};

export default MobileAcordion;
